class StickyCartBar extends HTMLElement {
  connectedCallback() {
    this.bindEvents();
    this.scrollCurrentTabIntoView();
    document.addEventListener('cart:refresh-sticky-bar', this.refresh.bind(this));

    // Also refresh on the theme's own cart pub/sub event (assets/pubsub.js +
    // assets/constants.js) -- this fires unconditionally on every cart
    // quantity/remove change and add-to-cart, even on paths where
    // cart.addFreebie() bails out early (e.g. cart just became empty) and
    // never reaches the cart:refresh-sticky-bar dispatch in cart-drawer.js.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh.bind(this));
    }
  }

  bindEvents() {
    this.toggleButton = this.querySelector('.sticky-cart-bar__toggle');

    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    const isExpanded = this.classList.toggle('is-expanded');
    this.toggleButton.setAttribute('aria-expanded', isExpanded);

    if (isExpanded) {
      this.scrollCurrentTabIntoView();
    }
  }

  refresh() {
    const previousFill = this.querySelector('.sticky-cart-bar__progress-fill');
    const previousWidth = previousFill ? previousFill.style.width : null;

    fetch(window.location.pathname + window.location.search)
      .then((response) => response.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('sticky-cart-bar');

        if (!fresh) {
          this.remove();
          return;
        }

        const wasExpanded = this.classList.contains('is-expanded');
        this.innerHTML = fresh.innerHTML;
        this.className = fresh.className;
        this.setAttribute('data-cart-qty', fresh.getAttribute('data-cart-qty'));

        if (wasExpanded) {
          this.classList.add('is-expanded');
        }

        this.animateProgressFill(previousWidth);
        this.bindEvents();
        this.scrollCurrentTabIntoView();
      })
      .catch(() => {});
  }

  // Keeps the unlocked-tier-in-progress tab reachable without manual
  // scrolling -- the tab row can overflow horizontally once several offers
  // are enabled, and the current tier isn't always the first one.
  scrollCurrentTabIntoView() {
    const track = this.querySelector('.sticky-cart-bar__tabs-sub-wrap');
    const current = this.querySelector('.offer-tab.is-current');
    if (!track || !current) return;

    const trackRect = track.getBoundingClientRect();
    const tabRect = current.getBoundingClientRect();
    const isFullyVisible = tabRect.left >= trackRect.left && tabRect.right <= trackRect.right;

    if (isFullyVisible) return;

    const targetScrollLeft =
      track.scrollLeft + (tabRect.left - trackRect.left) - (trackRect.width - tabRect.width) / 2;

    track.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  }

  // The progress fill's target width is already baked into the fresh markup
  // above, so a fresh DOM node has nothing to transition from. Rewind it to
  // the previous width, force a reflow, then let it transition forward to
  // the (already-set) target width on the next frame.
  animateProgressFill(previousWidth) {
    if (previousWidth === null) return;

    const fill = this.querySelector('.sticky-cart-bar__progress-fill');
    if (!fill) return;

    const targetWidth = fill.style.width;
    fill.style.transition = 'none';
    fill.style.width = previousWidth;
    void fill.offsetWidth;
    fill.style.transition = '';

    requestAnimationFrame(() => {
      fill.style.width = targetWidth;
    });
  }
}

customElements.define('sticky-cart-bar', StickyCartBar);

class StickyCartViewButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.openCart.bind(this));
  }

  openCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }
}

customElements.define('sticky-cart-view-button', StickyCartViewButton);